import { render, staticRenderFns } from "./popup.vue?vue&type=template&id=73c6a5f4&scoped=true"
import script from "./popup.vue?vue&type=script&lang=js"
export * from "./popup.vue?vue&type=script&lang=js"
import style0 from "./popup.vue?vue&type=style&index=0&id=73c6a5f4&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "73c6a5f4",
  null
  
)

export default component.exports